// link
import { Link, useNavigate, useLocation } from "react-router";
// style
import './style/header.css'
// routes
import { RoutesClient } from "../../features/routes/routes";
// icon
import { IconMenu2, IconPhoneCall, IconShoppingBag, IconUser, IconUserCircle } from "@tabler/icons-react";
// hook
import { useEffect, useState } from "react";
// mobile nav
import MobileNav from "../../components/mobileNav/mobileNav";
import HeaderNav from "../../components/headerNav/headerNav";
// controller
import useGetData from "../../hook/getData";
import { GetCategories } from "../../services/client/categories/getCategories";
// @ts-ignore
import Cookies from "js-cookie";
// context 
import { useCart } from "../../context/cartContext";
import { GetCarts } from "../../services/panel/cart/getCart";
import ModalSearch from "../../components/modal/search";
import CategoryModal from "../../components/modal/category";
import CategoryCollapse from "../../components/modal/categoryModal";
import OffCanvas from "../../components/mobileNav/offcanvas";
import { RoutesUser } from "./../../features/routes/userRouts";
import { getAllAddresses } from "../../features/address/address";



/* ------------------------------  NEW: NORMALIZER  ------------------------------ */
export function normalizeCategories(categories: any[]) {

    const map: any = {};
    const roots: any[] = [];

    // map
    categories.forEach(cat => {
        map[cat.id] = { ...cat, children: [] };
    });

    // build tree
    categories.forEach(cat => {

        if (cat.parents && cat.parents.length > 0) {

            cat.parents.forEach((parent: any) => {
                if (map[parent.id]) {
                    map[parent.id].children.push(map[cat.id]);
                }
            });

        } else {
            roots.push(map[cat.id]);
        }

    });

    return roots;
}

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
    const [categoryTree, setCategoryTree] = useState<any[]>([]);
    const [categoryId, setCategoryId] = useState<any>();
    const { data: carts } = useGetData(['carts'], GetCarts);
    const { data: categoires } = useGetData(['categories'], GetCategories);
    const closeMenu = () => setIsMenuOpen(false);
    const location = useLocation();

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    console.log(location.pathname)

    /* -------------------- APPLY NORMALIZED CATEGORY DATA -------------------- */
    useEffect(() => {
        if (categoires) {
            const tree = normalizeCategories(categoires);
            setCategoryTree(tree);
            document.getElementById('pages-header')?.classList.remove('d-none');
        }
    }, [categoires]);



    const navigate = useNavigate();

    const handleNavigate = (slug: string) => {
        navigate(`/categories/${slug}`);
        const closeModalButton: any = document.getElementById("close-modal");
        if (closeModalButton) closeModalButton.click();
    };

    const { cart } = useCart();
    const cartCount = cart.length;
    const currentPath = decodeURIComponent(location.pathname);
    const userRoutes = getAllAddresses(RoutesUser);
    const isUserRoute = userRoutes.includes(currentPath);

    return (
        <>
            <header id="pages-header" className="position-sticky bg-white pages-header" onMouseLeave={closeMenu}>
                <div className="container py-3 pb-2" onMouseMove={closeMenu}>
                    <div className="row justify-content-between align-items-center">
                        <div className="col-4 d-lg-none d-inline-block">
                            <IconMenu2 data-bs-toggle="offcanvas" data-bs-target={isUserRoute ? '#offcanvas-admin' : '#mobile-canvas'} />
                        </div>
                        <div className="col-4 ps-md-0 ps-4 ">
                            <Link className="navbar-brand" to="/">
                                <img alt="logo" src={require('./../../assets/media/logo/logo_new.png')} className="logo-img-new" />
                            </Link>
                        </div>
                        <div className="col-md-4 d-lg-inline-block d-none  position-relative">
                            <input data-bs-toggle="modal" data-bs-target="#modal-search" placeholder="به دنبال چه چیزی می گردید؟" className="form-control font-medium-lg rounded rounded-5 ms-2 py-2" />
                        </div>
                        <div className="col-md-3 col-4">
                            <div className="d-flex justify-content-end align-items-center gx-4">
                                {Cookies.get('agent_token') ? (
                                    <Link to={'/user/profile'} className="text-black">
                                        <IconUserCircle size={25} />
                                    </Link>
                                ) : (
                                    <IconUser className="text-black" data-bs-toggle="modal" data-bs-target="#agent" />
                                )}
                                <Link to={'/cart'} className="text-black position-relative mx-3 me-0">
                                    <IconShoppingBag size={25} />
                                    <span className="position-absolute top-0 font-small start-0 translate-middle badge rounded-pill bg-secondary">
                                        {carts?.cartItems?.length || cartCount}
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <nav className="navbar bg-white navbar-expand-lg py-0">
                    <section className="container">
                        <div className="collapse navbar-collapse justify-content-between align-items-center" id="navbarSupportedContent">
                            <ul className="navbar-nav align-items-center me-auto font-medium-lg mb-2 mb-lg-0">

                                <li className="nav-item">
                                    <span
                                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                                        data-bs-toggle="collapse"
                                        onMouseOver={() => setIsMenuOpen(true)}
                                        className="nav-link text-black mx-1"
                                    >
                                        <IconMenu2 className="me-2" />
                                        دسته بندی کالا
                                    </span>
                                </li>

                                {RoutesClient.map((address) => (
                                    <HeaderNav
                                        key={address.address}
                                        child={address.child}
                                        show={address.show}
                                        label={address.label}
                                        address={address.address}
                                    />
                                ))}

                            </ul>

                            <div className="actions d-lg-inline-block d-none">
                                <div className="d-flex align-items-center gx-4">
                                    <Link to={'tel:09373739843'} className="position-relative font-medium text-black text-decoration-none mx-1 p-2">
                                        <IconPhoneCall size={16} className="me-1" />
                                        09373739843
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                </nav>


                {isMenuOpen && (
                    <CategoryCollapse
                        closeModal={closeMenu}
                        parentCategory={categoryTree}
                        categoryId={categoryId}
                        setCategoryId={setCategoryId}
                    />
                )}

            </header>

            <CategoryModal parentCategory={categoryTree} handleNavigate={handleNavigate} />
            <ModalSearch />
            {location.pathname !== "/cart" && location.pathname !== '/shop' ? (
                <MobileNav routes={RoutesClient} />
            ) : null}
            <OffCanvas routes={RoutesClient} />
        </>
    );
};

export default Header;
